import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getDeviceDefaultConfiguration } from '../../services/DeviceService';
import { DeviceDefaultConfiguration } from '../../types/Devices';

/**
 * The default value of every device parameter, as declared by the FOTA service.
 *
 * The values are the same for every device and only change when the service is redeployed, so the
 * result is cached for the session rather than refetched per modal — the config modals call this on
 * mount to seed their form.
 */
function useGetDeviceDefaultConfiguration(): UseQueryResult<DeviceDefaultConfiguration> {
  return useQuery(
    ['device-default-configuration'],
    async (): Promise<DeviceDefaultConfiguration> => getDeviceDefaultConfiguration(),
    {
      retry: 1,
      retryDelay: 3000,
      staleTime: Infinity,
      cacheTime: Infinity,
      refetchOnWindowFocus: false,
    },
  );
}

export default useGetDeviceDefaultConfiguration;
